import { onChangeLanguage } from '../shared/DOM/onChangeLanguage';
import { removePageLoader } from '../shared/DOM/removePageLoader';

onChangeLanguage();
removePageLoader();
